import CssBaseline from '@mui/material/CssBaseline'
import useStore from 'reusable/mobx-store-utils'
import { observer } from 'mobx-react-lite'
import AuthGuard from 'auth/AuthGuard'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import ErrorBoundary from 'reusable/error/ErrorBoundary'
import { ThemeStore, ThemeStoreProvider } from 'theme/ThemeStore'
import PdfStore, { PdfStoreProvider } from 'reusable/pdf/PdfStore'
import { useEffect } from 'react'
import { NewVersionBanner } from 'reusable/app-version/NewVersionBanner'

export default observer(function MainView() {
   const themeStore = useStore(() => new ThemeStore())
   const pdfStore = useStore(() => new PdfStore())

   useEffect(() => {
      themeStore.setThemeVariables({
         propertyName: 'pdfFormat',
         newValue: pdfStore.isGeneratingPdf
      })
   }, [themeStore, pdfStore.isGeneratingPdf])

   return <ErrorBoundary>
      <ThemeStoreProvider store={themeStore}>
         <StyledEngineProvider injectFirst>
            <PdfStoreProvider store={pdfStore}>
               <ThemeProvider theme={themeStore.theme}>
                  <CssBaseline />
                  <AuthGuard />
                  <NewVersionBanner />
               </ThemeProvider>
            </PdfStoreProvider>
         </StyledEngineProvider>
      </ThemeStoreProvider>
   </ErrorBoundary>
})
